export default __webpack_public_path__ + "static/media/Incidents-4.abcabac1.png";